import styled from 'styled-components';

const Container = styled.div` 
display: block;
margin-top:55px ;
h1{
color: black;
margin-top:30px ;
margin-bottom:30px ;
}
.banner-img{
  height:433px ;
  object-fit:cover ; 
}
.event-mini-details{
  margin-left:10px ;
}
.event-mini-details li{
  list-style:none ;
}
.gallery-container button{
  background-color:#fa7525 ;
  border-radius:50px ;
  height:45px;
  width:45px;
  margin-top:100px ;
}
.event-title-small img{
  width:100% ;
  border-radius:10px ;

}
.event-title-small{
  /* display: flex; */

}
.event-banner h1{
    display: flex;
    align-items:center ;
    justify-content:center ;
}
.mid-colum-container{
  margin-top:50px ;
  padding:20px ;
  
}
.designing-thinking-grid{
  box-shadow:1px 1px 3px 1px lightgray;
  height: 300px;
  /* margin:5px ; */
}
.register-box{
  display: flex;
  align-items:center;
  justify-content:center;
  z-index:1;
}
li{
  list-style:none ;
}
.event-detail-design-thinking{
  z-index:-9 ;
}
.create-evolve-repeat img{
  width:100% ;
  margin-top:100px ;
  margin-bottom:100px ;
}

@media (max-width:615px){

  .hide-on-phone{
    display:none ;
  }
}
@media (max-width:1100px){
  .gallery-container button{
  height:40px;
  width:40px;
  margin-top:5em;
}
}

`
export {Container};